import React from "react"
import Header from "./Header"
import Footer from "./Footer"
import { withRouter } from "react-router-dom"
import { useGlobalContext } from "../context"

function Main(props: any) {
    const { globalState, dispatch } = useGlobalContext()

    // console.log("*****", props, globalState, dispatch)

    React.useEffect(() => {
        // call api to initilize the language info
    }, [])

    return (
        <React.Fragment>
            <Header lang={globalState.lang} />
            {props.children}
            <Footer lang={globalState.lang} />
        </React.Fragment>
    )
}

export default Main